export const BASE_URL = 'https://crm-api.qmeter.net/api';
export const ACCESS_TOKEN_KEY = 'access_token';
export const LS_USER_KEY = 'user';

export const DashboardPaginationOptions = {
    pageSize: 10,
    hideOnSinglePage: false,
    showSizeChanger: false,
};
